import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68ed8df0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "caron-container" }
const _hoisted_2 = { class: "container-left" }
const _hoisted_3 = { class: "container-center" }
const _hoisted_4 = { class: "contain-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_general_status = _resolveComponent("general-status")!
  const _component_green_area = _resolveComponent("green-area")!
  const _component_monit_list = _resolveComponent("monit-list")!
  const _component_caronMap = _resolveComponent("caronMap")!
  const _component_time_monit = _resolveComponent("time-monit")!
  const _component_caronNPP = _resolveComponent("caronNPP")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_general_status),
      _createVNode(_component_green_area),
      _createVNode(_component_monit_list)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_caronMap),
      _createVNode(_component_time_monit)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_caronNPP, { "caron-type": "NPP" }),
      _createVNode(_component_caronNPP, { "caron-type": "GPP" }),
      _createVNode(_component_caronNPP, { "caron-type": "NEP" })
    ])
  ]))
}